import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaTiktok, FaLinkedin, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-links">
          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/join">Careers</Link></li>
              <li><a href="/files/CIAP Company Profile.pdf" download>Company Profile</a></li>
              <li><Link to="/sectors">Sectors</Link></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Support</h4>
            <ul>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/news">News</Link></li>
              <li><Link to="/news">Latest Update</Link></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms &amp; Conditions</Link></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Follow Us</h4>
            <div className="social-links">
              <a href="https://www.facebook.com/ciappvtltd" target="_blank" rel="noopener noreferrer" aria-label="CIAP Facebook"><FaFacebook /></a>
              <a href="https://www.instagram.com/ciappvtltd/" target="_blank" rel="noopener noreferrer" aria-label="CIAP Instagram"><FaInstagram /></a>
              <a href="https://www.linkedin.com/company/ciap-pvt-ltd/" target="_blank" rel="noopener noreferrer" aria-label="CIAP LinkedIn"><FaLinkedin /></a>
              <a href="https://www.tiktok.com/@ciap.pvt.ltd" target="_blank" rel="noopener noreferrer" aria-label="CIAP TikTok"><FaTiktok /></a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} CIAP Ltd. All rights reserved.</p>
          <p>
            Powered by<a style={{ color: "green", textDecoration: "none" }} href="https://invictustechno.com" target="_blank" rel="noopener noreferrer"> INVICTUS TECHNOLOGY</a>
          </p>



        </div>
      </div>
    </footer>
  );
};

export default Footer;

